/* globals wpa_data */
require( './load-more' );
require( './quantity' );

jQuery( ( $ ) => {
	$( 'a.menu-toggle' ).on( 'click', ( e ) => {
		if ( $( e.target ).attr( 'aria-expanded' ) === 'false' ) {
			$( '.menu-container' ).fadeIn( 150 );
			$( e.target ).text( 'lukk' );
			$( e.target ).addClass( 'vertical' );
			$( e.target ).attr( 'aria-expanded', 'true' );
		} else {
			$( '.menu-container' ).fadeOut( 150 );
			$( e.target ).text( 'meny' );
			$( e.target ).removeClass( 'vertical' );
			$( e.target ).attr( 'aria-expanded', 'false' );
		}
	} );
} );

jQuery( ( $ ) => {
	$( 'li.product' ).removeClass( 'first' );
	$( 'li.product' ).removeClass( 'last' );
} );

jQuery( ( $ ) => {
	let isOpen = false;
	$( '.widget_product_categories .widget-title' ).append( '<span class="icon-plus">↓</span>' );
	$( '.widget_product_categories .widget-title' ).on( 'click', function() {
		if ( ! isOpen ) {
			$( this ).parent().children( '.product-categories' ).slideDown();
			$( this ).find( '.icon-plus' ).css( 'transform', 'rotate(180deg)' );
			isOpen = ! isOpen;
		} else {
			$( this ).parent().children( '.product-categories' ).slideUp();
			$( this ).find( '.icon-plus' ).css( 'transform', 'rotate(0deg)' );
			isOpen = ! isOpen;
		}
	} );
} );

jQuery( ( $ ) => {
	let isOpen = false;
	$( 'ul li .icon-plus' ).on( 'click', function( e ) {
		if ( ! isOpen ) {
			$( e.target ).parent().find( 'ul' ).slideDown();
			$( e.target ).text( '-' );
			isOpen = ! isOpen;
		} else {
			$( e.target ).parent().find( 'ul' ).slideUp();
			$( e.target ).text( '+' );
			isOpen = ! isOpen;
		}
	} );
} );

jQuery( ( $ ) => {
	if ( $( '.posts-loop' ).find( 'a.more-posts' ).length !== 0 ) {
		$( '.posts-loop' ).css( 'padding-bottom', '40px' );
	} else {
		$( '.posts-loop' ).css( 'padding-bottom', '0' );
	}
} );

jQuery( ( $ ) => {
	const windowsize = $( window ).width();
	if ( windowsize > 1024 ) {
		if ( $( '.wp-post-image-wrapper' ).find( 'img.wp-post-image' ).length !== 0 ) {
			$( '.single-post-date' ).css( 'padding-top', '60px' );
		} else {
			$( '.single-post-date' ).css( 'padding-top', '10px' );
		}
	}
} );

// Dette er for å få fine lister av PDF-ar.
// Hekkan det er dårleg kode dette greiene.
jQuery( ( $ ) => {
	$( 'p:has(a[href$=".pdf"])' ).attr( 'style', 'margin-bottom: 0px !important' );
} );

jQuery( ( $ ) => {
	$( '.widget_product_categories' ).on( 'click', function() {
		const ex = $( '.select2-results__options' ).find( '.select2-results__option--shop' );
		if ( ex.length ) {

		} else {
			$( 'ul.select2-results__options' ).prepend( '<li class="select2-results__option--shop" ><a href="' + wpa_data.shop_path + '">Vis alle varer</a></li>' );
			$( '.select2-results__option--shop' ).hover(
				function() {
					$( 'ul.select2-results__options li' ).removeClass( 'select2-results__option--highlighted' );
				}
			);
		}
	} );
} );

/* Bli medlem-form */
jQuery( ( $ ) => {
	// Why did they think this was a good idea? :o
	// $( 'form.makismer-reg-form input' ).on( 'invalid', function( event ) {
	// 	event.preventDefault();
	// 	$( '.makismer-reg-form' ).find( ':invalid' ).first().focus();
	// } );
	try {
		document.querySelector( '.makismer-reg-form' ).addEventListener( 'submit', ( e ) => {
			const elm = e.target.elements;
			// store stuff for the autofilling of Stripe-fields
			const data = JSON.stringify( {
				first_name: elm.reg_first_name.value,
				last_name: elm.reg_last_name.value,
				postcode: elm.reg_zip.value,
				address_1: elm.reg_address.value,
				city: elm.reg_postcode.value,
				phone: elm.reg_phone.value,
				email: elm.reg_email.value,
			} );
			try {
				sessionStorage.bliMedlemData = data;
			} catch ( e2 ) {
				// Likely Firefox in Private mode, we can't use session data
				// so just use ?get param to send it :shrug:
				elm.nm_forward_data.value = btoa( data );
			}
		} );
	} catch ( e ) {}
	$( '#shipping_company_field label' ).append( '<p>(om du bestiller på vegner av eit lokallag)</p>' );
	$( document ).ajaxComplete( () => {
		try {
			$( '.wc_payment_methods li label[for="payment_method_stripe"]' ).contents().filter( function() {
				return this.nodeType === 3;
			} )[ 0 ].nodeValue = 'Kortbetaling';
		} catch ( e ) {}
	} );
	try {
		if ( document.querySelector( '.woocommerce-checkout' ) ) {
			// Berre endra form på blimedlem-sida
			if ( location.search.indexOf( 'blimedlem' ) === -1 ) {
				return;
			}
			let data;
			try {
				data = JSON.parse( sessionStorage.bliMedlemData );
			} catch ( e ) {
				// Firefox in Private mode again, falling back, shouldn't happen often
				const m = /blimedlem=([\w\d]*)/.exec( location.search );
				data = JSON.parse( atob( m && m[ 0 ] ) );
			}
			// Set values from URL params
			[ 'first_name', 'last_name', 'postcode', 'address_1', 'city', 'phone', 'email' ].forEach( function( k ) {
				const v = data[ k ];
				if ( ! v ) {
					return;
				}
				const elm = document.querySelector( '#billing_' + k );
				if ( ! elm ) {
					return;
				}
				elm.value = v;
			} );
			// Hide details user shouldn't need to change based on stripe error
			[ 'phone', 'email', 'city', 'company' ].forEach( ( k ) => {
				document.querySelector( '#billing_' + k + '_field' ).hidden = true;
			} );
			// Some other cleanups for 'blimedlem' case
			document.querySelector( '.woocommerce-billing-fields h3' ).textContent = 'Betalingsinformasjon';
			document.querySelector( '.woocommerce-shipping-fields' ).hidden = true;
			document.querySelector( '.woocommerce-additional-fields' ).hidden = true;
			delete sessionStorage.bliMedlemData;
		}
	} catch ( e ) {}
} );


jQuery( () => {
	const ktacc = document.querySelector(".wp-block-kadence-accordion");
	// No accordion, so nothing to do in any case
	if (!ktacc) return;
	ktacc.addEventListener('click', (e) => {
		const lag = e.path.find(elm => elm.classList?.contains("nm-local-chapter"));
		if (lag) location.hash = '#' + lag.id;
	});
	if (location.hash.length < 2) return;
	try {
		const elm = document.getElementById(decodeURIComponent(location.hash.slice(1)));
		const accordion = elm.closest(".kt-accordion-pane");
		if (!accordion) return;
		// Okay, we're in an accordion and a child has been selected
		setTimeout(() => {
			accordion.querySelector("button").click(); // open
			// This is super hacky and because kt-accordion doesn't
			// support æøå and won't scroll to the child. Also, it
			// doesn't have a good way to extend :'(
			setTimeout(() => elm.scrollIntoView(), 500);
		}, 100);
	} catch (e) {}
} );
